import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import React from 'react';
import RowProductVirtual from './RowProductVirtual';

const TableProductsVirtual = ({products, onEmitCount, deleteComplect}) => {
  return (
    <Paper sx={{mx: 4, mt: 4}}>
      <TableContainer component={Paper}>
        <Table stickyHeader size='small'>
          <TableHead style={{ backgroundColor: '#F6F8FB' }}>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>АРТИКУЛ</TableCell>
              <TableCell>НАЗВАНИЕ ТОВАРА</TableCell>
              <TableCell>КОЛ-ВО</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              products.map(element => {
                return (
                  <TableRow
                    style={{
                      position: 'relative',
                    }}
                    key={element.id}
                  >
                    <RowProductVirtual product={element} onEmitCount={onEmitCount} deleteComplect={deleteComplect}  />
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
} 

export default TableProductsVirtual